export default {"src":"/_next/static/media/social.78c66fa0.svg","height":24,"width":20,"blurWidth":0,"blurHeight":0};